<template>
  <div class="d-flex flex-column justify-content-start gap-2">
    <fieldset :disabled="!isEditing.value">
      <div class="title bg-success">Trecho</div>
      <div class="col-auto">
        <label for="nome" class="col-form-label">Nome</label>
      </div>
      <div class="col-auto">
        <input type="text" v-model="section.name" id="nome" class="form-control">
      </div>

      <div class="col-auto">
        <label for="version" class="col-form-label">Ponto A</label>
        <SelectTriggers v-if="section?.company?.id" :pointInit="section.pointA" :company_id="this.section.company.id"
          @update:point="updatePointA"></SelectTriggers>
        <label for="version" class="col-form-label">Ponto B</label>
        <SelectTriggers v-if="section?.company?.id" :pointInit="section.pointB" :company_id="this.section.company.id"
          @update:point="updatePointB"></SelectTriggers>
      </div>

      <div class="col-auto">
        <label for="assignor" class="col-form-label">Cedente</label>
      </div>
      <div class="col-auto">
        <select v-model="section.assignor" class="form-control" id="assignor">
          <option :value="null">Eu mesma</option>
          <option v-for="partner in partnersOptions" :key="partner.id" :value="partner">
            {{ partner.id }} - {{ partner.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="assignees" class="col-form-label">Cessionários</label>
        <div class="form-check">
          <input type="checkbox" class="form-check-input" v-model="section.isSelfAssignee">
          <label class="form-check-label">
            Eu mesma
          </label>
          <div v-for="partner in partnersOptions" :key="partner.id">
            <input type="checkbox" class="form-check-input" :id="'assignee-' + partner.id" :value="partner"
              v-model="section.assignees">
            <label :for="'assignee-' + partner.id" class="form-check-label">
              {{ partner.id }} - {{ partner.name }}
            </label>
          </div>
        </div>
      </div>

      <button v-if="isEditing.value" @click="saveSection" type="button" class="actions btn btn-success btn-sm">
        Salvar
      </button>

      <div class="title subtitle">Playbook</div>
      <div class="form-group">
        <button v-if="!section.playbook" @click="addPlaybook()" type="button" class="actions btn btn-success btn-sm">
          Criar Playbook
        </button>

        <div v-if="section.playbook" class="form-group">
          <PlaybookEdit :active-jump="true" v-model="section.playbook" :companyId="this.section.company.id" :sectionId="this.section.id"/>
        </div>

        <button v-if="section.playbook" @click="deletePlaybook()" type="button" class="actions btn btn-danger btn-sm">
          Deletar Playbook
        </button>
      </div>
    </fieldset>
  </div>
</template>

<script>
import SelectTriggers from "@/components/SelectTriggers.vue";
import useEditMode from "@/services/EditingService";
import PlaybookEdit from "../playbooks/PlaybookEdit.vue";
import { CompanyService, PartnerService, playbookService, PointService, sectionService } from "@/services/backend/ApiService";

export default {
  components: {
    SelectTriggers,
    PlaybookEdit
  },
  data() {
    return {
      section: {},
      listPops: [],
      partnersOptions: "",
      problemA: false,
      problemB: false
    };
  },
  setup() {
    const isEditing = useEditMode();

    return { isEditing };
  },
  methods: {
    async loadSectionData(id) {
      try {
        this.section = await sectionService.findOne(id);
        this.partnersOptions = await PartnerService.findAll({ company: {id: this.section.company.id} });
      } catch (error) {
        console.error("Erro ao carregar os dados do Section:", error);
      }
    },
    updatePointA(newPoint) {
      this.section.pointA = { ...newPoint };
    },
    updatePointB(newPoint) {
      this.section.pointB = { ...newPoint };
    },
    async saveSection() {
      try {
        await sectionService.update(this.section.id, this.section);

        if(!this.section.pointA.id){
          await PointService.create(this.section.pointA)
        }else{
          await PointService.update(this.section.pointA.id,this.section.pointA)
        }

        if(!this.section.pointB.id){
          await PointService.create(this.section.pointB)
        }else{
          await PointService.update(this.section.pointB.id,this.section.pointB)
        }

      } catch (error) {
        console.error("Erro ao salvar Section:", error);
      }
    }
  },
  async mounted() {
    const SectionId = this.$route.params.id;

    const problem = this.$route.query.problem;
    if (problem === "pointA") {
      this.problemA = true;
    }

    if (problem === "pointB") {
      this.problemB = true;
    }

    if (SectionId) {
      await this.loadSectionData(SectionId);
      this.listPops = (await CompanyService.findOne(this.section.company.id)).pops;
    }
  },
};
</script>

<style scoped>
.form-check {
  max-height: 400px;
}
</style>
